/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/lib/utils/userUtils"/>
import { get } from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";

export function canCurrentUserModifyPasswordOfUser(userId: number) {
    return get(`users/current/can-modify-password-of-user/${userId}`);
}
